import { Stack, ViewHeader, ViewItemField } from '@fukuri-admins/ui/common';

type Props = {
  /** 利用者氏名 */
  fullName: string;
  /** メールアドレス（未設定の場合は '-'） */
  email: string;
  /** 利用企業名 */
  clientName: string;
  /** 店番（未連携の場合は '-'） */
  branchCode: string;
  /** 口座番号（未連携の場合は '-'）。PEN-1696 により 2026 年 11 月末まで描画しない（PEN-1697 で戻す） */
  accountNumber: string;
  /** 連携日時（未連携の場合は '-'） */
  linkedAtLabel: string;
  /** 利用開始日の表示ラベル（null の場合は '-'） */
  billableFromLabel: string;
  /** 作成日時（表示整形済み） */
  createdAtLabel: string;
  /** 更新日時（表示整形済み） */
  updatedAtLabel: string;
  /** 編集リンク */
  editLink: string;
  /**
   * カスタムフィールドの表示アイテム一覧（空配列の場合はセクション非表示）
   */
  customFields: {
    /** 表示ラベル */
    label: string;
    /** 整形済みの表示値 */
    value: string;
  }[];
};

/**
 * 利用者詳細プロフィール（BankAccount）Presentation
 *
 * 中国銀行向けの表示仕様に絞り込んだ版。
 * 表示項目: 利用企業名 / メールアドレス / 店番 / 連携日時 / 利用開始日 / カスタムフィールド（存在する場合） / 作成日時 / 更新日時
 */
export const UserDetailProfileBankAccountPresentation: React.FC<Props> = ({
  fullName,
  email,
  clientName,
  branchCode,
  linkedAtLabel,
  billableFromLabel,
  createdAtLabel,
  updatedAtLabel,
  editLink,
  customFields,
}) => (
  <Stack direction='column' gap={24}>
    <ViewHeader title={fullName} editLink={editLink} />
    <Stack direction='column' gap={24}>
      <ViewItemField label='利用企業名' direction='row' value={clientName} />
      <ViewItemField label='メールアドレス' direction='row' value={email} />
      <ViewItemField label='店番' direction='row' value={branchCode} />
      <ViewItemField label='連携日時' direction='row' value={linkedAtLabel} />
      <ViewItemField label='利用開始日' direction='row' value={billableFromLabel} />
      {customFields.length > 0 &&
        customFields.map(field => (
          <ViewItemField
            key={field.label}
            label={field.label}
            direction='row'
            value={field.value}
          />
        ))}
      <ViewItemField label='作成日時' direction='row' value={createdAtLabel} />
      <ViewItemField label='更新日時' direction='row' value={updatedAtLabel} />
    </Stack>
  </Stack>
);
